import React, { useState, useEffect, useCallback } from "react";
import { Typography, Button, TextField, Grid } from "@mui/material";
import useStyles from "./style";
import { useFormik } from "formik";
import * as yup from "yup";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

//
import TextEditor from "./TextEditor";

//Api routes
import settingsApi from "Services/Settings";

const Settings = () => {
  //
  const classes = useStyles();
  const dispatch = useDispatch();
  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );
  const userid = useSelector(
    (state) => state?.AuthReducer?.userId || ""
  );

  //
  const [values, setValues] = useState([]);
  const [htmlContent, setHtmlContent] = useState("");

  // Get Legal Settings
  const LegalSettings = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const params = {};
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    } else if (userid) {
      params.userid = userid;
    }
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setValues(res?.data?.data);
      } else {
        setValues([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.getprivacySettings(params).then(onSuccess, onFailure);
  }, [demoaccount_id, userid]);

  useEffect(() => {
    LegalSettings();
  }, [LegalSettings]);

  //

  const handleSettings = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      pageTitle: formValues?.pageTitle,
      content: cmsHtmlContent,
      demoaccount_id: demoaccount_id,
      userid: userid,
    };

   // console.log('data-->',data);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated privacy policy successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while updating privacy policy and conditions",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    settingsApi.updateprivacySettings({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      pageTitle: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      newPassword: yup
        .string()
        .min(6, "Must be greater than 6 characters or long")
        .max(16, "Must be less than 16 character or equal to 16"),
    }),
    onSubmit: handleSettings,
  });

  const [cmsHtmlContent, setCmsHtmlContent] = useState("");

  useEffect(() => {
    if (!_.isEmpty(values)) {
      formik.setFieldValue("pageTitle", values?.pageTitle);
    }
    setHtmlContent(values?.content);
  }, [values]);

  //

  const handleHtmlContentChange = (newContent) => {
 //   console.log('new content-->',newContent)
    setCmsHtmlContent(newContent);
  };

  return (
    <>
      <br></br>
      <br></br>
      <Grid container className={classes.cardContainer}>
        <Grid
          item
          xs={12}
          md={12}
          lg={12}
          xl={12}
          className={classes.businessSettingsContainer}
        >
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            className={classes.container}
          >
            <div style={{ padding: "0px 0px" }}>
              <Typography variant="h5">Privacy Policy</Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={12} lg={12} xl={12}>
            {/* Enable Mail */}
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.editorWrapper}
            >
              <TextField
                name="pageTitle"
                id="pageTitle"
                label="Page Title"
                value={formik?.values?.pageTitle}
                defaultValue={formik?.values?.pageTitle}
                onChange={formik?.handleChange}
                error={formik?.errors?.pageTitle && formik?.touched?.pageTitle}
                helperText={
                  formik?.errors?.pageTitle &&
                  formik?.touched?.pageTitle &&
                  formik?.errors?.pageTitle
                }
                fullWidth
                variant="outlined"
                size="small"
              ></TextField>
            </Grid>

            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              xl={12}
              className={classes.editorWrapper}
            >
              <TextEditor
                key={htmlContent}
                initialHtmlContent={htmlContent || ""}
                onHtmlContentChange={handleHtmlContentChange}
              />
            </Grid>

            <Grid item xs={12} md={6} lg={12} xl={12} className={classes.btn}>
              <Button variant="contained" onClick={formik.handleSubmit}>
                Update
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
    </>
  );
};

export default Settings;
